export default "__VITE_ASSET__BtcACKhl__"